// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  faqs: '/faqs',
  // AUTH
  auth: {
    jwt: {
      signIn: `${ROOTS.AUTH}/jwt/sign-in`,
    },
    authRedirect: '/auth-redirect', // This is the redirect path for the Entra instance in Azure,
    // it can't be changed in code alone, it must be accompanied
    // by configuring the new path in the Entra instance first.
    authLogout: '/auth-logout',
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    support_queue: `${ROOTS.DASHBOARD}/support-queue`,
    advanced_search: `${ROOTS.DASHBOARD}/advanced-search`,
    employer_data: {
      root: `${ROOTS.DASHBOARD}/employer-data`,
      combo: `${ROOTS.DASHBOARD}/employer-data/combo`,
      combo_details: (comboId: string) => `${ROOTS.DASHBOARD}/employer-data/combo/${comboId}`,
      coverage: `${ROOTS.DASHBOARD}/employer-data/combo/coverage`,
      coverage_details: (comboId: string, coverageId: string) =>
        `${ROOTS.DASHBOARD}/employer-data/combo/${comboId}/coverage/${coverageId}`,
      policy: `${ROOTS.DASHBOARD}/employer-data/combo/coverage/policy`,
      policy_details: (comboId: string, coverageId: string, policyId: string) =>
        `${ROOTS.DASHBOARD}/employer-data/combo/${comboId}/coverage/${coverageId}/policy/${policyId}/policy-details`,
      assigned_risk_application: {
        prePolicyDetails: (comboId: string | number, coverageId: string | number, assignedRiskAppId: string | number) =>
          `${ROOTS.DASHBOARD}/employer-data/combo/${comboId}/coverage/${coverageId}/assigned-risk-application/${assignedRiskAppId}`,
        details: (comboId: string | number, coverageId: string | number, policyId: string | number, assignedRiskAppId: string | number) =>
          `${ROOTS.DASHBOARD}/employer-data/combo/${comboId}/coverage/${coverageId}/policy/${policyId}/assigned-risk-application/${assignedRiskAppId}`,
      },
      usr_details: (comboId: string, coverageId: string, policyId: string, reportNumber: number, correctionSequenceNumber: number) =>
        `${ROOTS.DASHBOARD}/employer-data/combo/${comboId}/coverage/${coverageId}/policy/${policyId}/policy-details/usr-details/${reportNumber}/${correctionSequenceNumber}`,
    },
    data_management: {
      root: `${ROOTS.DASHBOARD}/data-management`,
      rejected_transactions: `${ROOTS.DASHBOARD}/data-management/rejected-transactions`,
    },
    unit_stat_reports: {
      root: `${ROOTS.DASHBOARD}/unit-stat-reports`,
      detail: (id: string) => `${ROOTS.DASHBOARD}/unit-stat-reports/${id}`,
    },
    three: `${ROOTS.DASHBOARD}/three`,
  },
};
